import React from 'react';
import { connect } from 'react-redux';

import Checkout from './Checkout';

import { updateOrder, getCheckout } from 'actions/orders';
import { getCard, getSession, addCard } from 'actions/session';

import {
  strataSelector,
  strataCertSelector,
  certificateSelector,
  addressDisplaySelector
} from 'selectors/order-create';

import { getPlanParcel } from 'utils';

export default connect(
  (state) => ({
    items: state.pendingOrder.items,
    order: state.pendingOrder.pending,
    activeCard: state.session.card,
    loading: state.loading.loadingOrder,
    loadingCard: state.loading.loadingCard,
    is_postpaid: state.session.account.is_postpaid,
    loadingCheckout: state.loading.loadingCheckout,
    loadingSessionUpdate: state.loading.loadingSessionUpdate,
    selectedStrata: strataSelector(state),
    selectedStrataCert: strataCertSelector(state),
    addressDisplay: addressDisplaySelector(state),
    selectedCertificate: certificateSelector(state),
    serviceFee: state.session.service_fee,
    is_admin: state.session.is_admin,
    titleServiceFee: state.session.title_service_fee,
    form1ServiceFee: state.session.form1_service_fee,
    strataServiceFee: state.session.strata_service_fee,
    strataFinancialsServiceFee: state.session.strata_financials_service_fee
  }),
  {
    dispatchGetCard: getCard,
    dispatchAddCard: addCard,
    dispatchGetCheckout: getCheckout,
    dispatchOrderUpdate: updateOrder,
    dispatchUpdateSession: getSession
  })(props => {
   
    return <Checkout 
      {...props}

      complete={props.order.complete}
      titleDocument={props.order.title}
      orderTitle={props.order.order_title}
      selectedCouncil={props.order.selected_council}
      planParcel={getPlanParcel(props.order)}
      onComplete={props.nextStep}
      is_admin={props.is_admin}
      fetchCard={props.dispatchGetCard}
      addCard={props.dispatchAddCard}
      updateOrder={props.dispatchOrderUpdate}
      updateSession={props.dispatchUpdateSession}
      getCheckout={props.dispatchGetCheckout}
      loadingCard={props.loadingCard}
      loadingCheckout={props.loadingCheckout}

      serviceFee={parseFloat(props.serviceFee)}
      form1ServiceFee={parseFloat(props.form1ServiceFee)}
      titleServiceFee={parseFloat(props.titleServiceFee)}
      strataServiceFee={parseFloat(props.strataServiceFee)}
      strataFinancialsServiceFee={parseFloat(props.strataFinancialsServiceFee)}
    />
  }
);